import { useMutation } from "@tanstack/react-query";

import { axiosPostData } from "@shared/api/clients";

export const acceptDocument = async (id: string): Promise<void> => {
  await axiosPostData<void, object>(`v1/legal-documents/${id}/accept`, {});
};

export const useAcceptDocumentMutation = () => {
  return useMutation({
    mutationFn: (id: string) => acceptDocument(id),
  });
};
